import $ from 'jquery';

let scrollPosi;
$('.js-modal').each(function () {
  $(this).on('click', function () {
    scrollPosi = $(window).scrollTop();
    $('body').css({
      position: 'fixed',
      'overflow-y': 'scroll',
      width: '100%',
      'z-index': '1',
      top: -scrollPosi,
    });
    let dataModal = $(this).data('modal');
    $('.js-modalContent[data-modal=' + dataModal + ']').addClass('is-show');
    return false;
  });
});

$('.js-modalContent').click(function (event) {
  if (event.currentTarget !== event.target) {
    return;
  }
  $('.js-modalClose').trigger('click');
});
$('.js-modalClose').on('click', function () {
  $('body').removeAttr('style');
  $('html,body').animate({ scrollTop: scrollPosi }, 0);
  $('.js-modalContent').removeClass('is-show');
  // $(".js-modalContent iframe").attr("src", $(".js-modalContent iframe").attr("src"));
  $(this).parents('.js-modalContent').find("iframe").attr("src", $(this).parents('.js-modalContent').find("iframe").attr("src"));
});



//modal slide
$('.js-slide1 .c-slide1__img').each(function (e) {
  $(this).on('click', function () {
    if ($(window).outerWidth() > 767) {
      scrollPosi = $(window).scrollTop();
      $('body').css({
        position: 'fixed',
        'overflow-y': 'hidden',
        width: '100%',
        'z-index': '1',
        top: -scrollPosi,
      });
      $('.c-slidepopup').addClass('is-show');
    }
  });
});

$('.c-slidepopup__close').on('click', function () {
  if ($(window).outerWidth() > 767) {
    defaultBody('.c-slidepopup');
  }
})


$('.c-slidepopup, .c-slidepopup__inner').on('click', function (e) {
  if ($(window).outerWidth() > 767) {
    if (e.target == this) {
      defaultBody('.c-slidepopup');
    }
  }
});

function defaultBody(param1) {
  $('body').removeAttr('style');
  $('html,body').animate({ scrollTop: scrollPosi }, 0);
  $(param1).removeClass('is-show');
}